'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import {Iterable} from 'immutable';
import classnames from 'classnames';

export default class FreeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHidden: true
    };
  }
  render() {
    const content = Iterable.isIterable(this.props.content)
      ? this.props.content.toJS()
      : this.props.content;

    var text = content.text;
    if (text) {
      text = marked(text);
    } else {
      text = 'No content entered.';
    }
    const isHidden = this.state.isHidden;
    const toggleClasses = classnames('free-form-toggle', 'fa', {
      'fa-caret-right': isHidden,
      'fa-caret-down': !isHidden
    });

    const contentClasses = classnames('free-form-content', {
      'is-hidden': isHidden
    });
    return (
      <div className='free-form'>
        <div
          onClick={() => {
            this.setState({
              isHidden: !this.state.isHidden
            });
          }}
          className={toggleClasses}
        />
        <div dangerouslySetInnerHTML={{__html: text}} className={contentClasses} />
      </div>
    );
  }
}

FreeForm.propTypes = {
  content: PropTypes.object
};

FreeForm.defaultProps = {
  content: {
    text: ''
  }
};
